import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const HexagonIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 22 24"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M9.5 0.866026C10.4282 0.330127 11.5718 0.330127 12.5 0.866025L19.8923 5.13397C20.8205 5.66987 21.3923 6.66025 21.3923 7.73205V16.2679C21.3923 17.3397 20.8205 18.3301 19.8923 18.866L12.5 23.134C11.5718 23.6699 10.4282 23.6699 9.5 23.134L2.1077 18.866C1.17949 18.3301 0.607696 17.3397 0.607696 16.268V7.73205C0.607696 6.66025 1.17949 5.66987 2.1077 5.13397L9.5 0.866026Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(HexagonIcon);
